/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type {
  AverageReportType,
  GroupType,
  HighlightedProps,
  ProgressConsistencyGroupType,
  SchoolReportType } from '../../types';
import { progress_consistency_groups } from '../../types';
import { SectionLayout } from '../modules';
import { APP_THEME } from '../../../styles/theme/styled/theme';
import SchoolProgressConsistencyGroup from '../../../components/charts/progress-consistency/SchoolProgressConsistencyGroup';
import type { ChartIconType } from '../../../components/charts/types';

const groups_colors: Record<ProgressConsistencyGroupType, string> = {
  occasional: APP_THEME.colors.rookie,
  intermittent: APP_THEME.colors.apprentice,
  steady: APP_THEME.colors.pro,
  reliable: APP_THEME.colors.master,
  constant: APP_THEME.colors.superstar,
};

// TODO Change when school data can be fetched
type Props = {
  schoolReport: SchoolReportType
  showOthersData: boolean
  iconToUse: ChartIconType
} & HighlightedProps;

const SchoolProgressConsistency = ({ schoolReport, showOthersData, highlightedLabel, highlightedIds, iconToUse }: Props): JSX.Element => {
  const { translate } = useI18n();

  const getHighlightedValue = (): number | null => {
    const highlightedGr = dataToUse().find((cl) => (highlightedIds.includes(cl.id)));

    if (highlightedIds && highlightedIds.length > 0 && highlightedGr) {
      return highlightedGr.consistencyAverage;
    }

    return null;
  };

  const dataToUse = (): (GroupType & AverageReportType)[] => {
    if (iconToUse === 'class') {
      return schoolReport.classes;
    } else {
      return schoolReport.yearGroups;
    }
  };

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.PROGRESS_CONSISTENCY.title')}
      value={schoolReport.average.consistencyAverageName}
      highlightLabel={highlightedLabel}
      highlightValue={getHighlightedValue()}
      moreInfo={translate('pages.REPORTS.SECTIONS.PROGRESS_CONSISTENCY.info')}
      id={'school-progress-consistency-container'}
    >
      <div className={'md:grid grid-cols-5 grid-flow-row'}>
        {progress_consistency_groups.map((group) => (
          <SchoolProgressConsistencyGroup
            showOthersData={showOthersData}
            key={`progress_consistency_${group}`}
            headline={translate(`pages.REPORTS.PROGRESS_CONSISTENCY.${group}`)}
            background={groups_colors[group]}
            groups={dataToUse().filter((cl) => {
              if (!showOthersData) {
                return cl.consistencyAverageName === group && highlightedIds.includes(cl.id);
              } else {
                return cl.consistencyAverageName === group;
              }
            })}
            highlightedIds={highlightedIds}
            iconToUse={iconToUse}
          />
        ))}
      </div>
    </SectionLayout>
  );
};

SchoolProgressConsistency.displayName = 'SchoolProgressConsistency';

export default SchoolProgressConsistency;

